/** Лимит строк вывода раннера (один на весь сайт). */

export const DEFAULT_MAX_OUTPUT_LINES = 2000;
export const MIN_MAX_OUTPUT_LINES = 2000;
export const MAX_MAX_OUTPUT_LINES = 10_000;

const MIN_OUTPUT_CHARS = 64 * 1024;
const MAX_OUTPUT_CHARS_CAP = 2 * 1024 * 1024;

export function clampMaxOutputLines(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return DEFAULT_MAX_OUTPUT_LINES;
  return Math.min(MAX_MAX_OUTPUT_LINES, Math.max(MIN_MAX_OUTPUT_LINES, Math.round(n)));
}

/** Символьный бюджет: не ниже 64 КБ, ~строки×128, не выше 2 МБ. */
export function maxOutputCharsForLines(maxLines) {
  const lines = clampMaxOutputLines(maxLines);
  return Math.min(MAX_OUTPUT_CHARS_CAP, Math.max(MIN_OUTPUT_CHARS, lines * 128));
}

export function trimOutputText(text, maxLines = DEFAULT_MAX_OUTPUT_LINES, maxChars) {
  if (!text) return '';
  let next = text;
  const lineLimit = clampMaxOutputLines(maxLines);
  const charLimit = maxChars != null
    ? Math.max(MIN_OUTPUT_CHARS, Math.min(MAX_OUTPUT_CHARS_CAP, Math.round(Number(maxChars)) || MIN_OUTPUT_CHARS))
    : maxOutputCharsForLines(lineLimit);
  const lines = next.split('\n');
  if (lines.length > lineLimit) {
    next = lines.slice(-lineLimit).join('\n');
  }
  if (next.length > charLimit) {
    next = next.slice(-charLimit);
  }
  return next;
}
